import { Service, ServiceScreenshot } from '../types';
import rehabLogo from '../assets/images/subdomains/rehab/brand=rehab.png';
import menhelyLogo from '../assets/images/subdomains/menhely/brand=menhely.png';
import gazdiLogo from '../assets/images/subdomains/gazdi/brand=gazdi.png';

const appShot = (
  service: 'menhely' | 'gazdi',
  index: number,
  hu: string,
  en: string
): ServiceScreenshot => ({
  id: `${service}-${index}`,
  titleKey: `services.${service}.screenshots.${index}.title`,
  descriptionKey: `services.${service}.screenshots.${index}.description`,
  src: {
    hu: `/content/images/apps/${service}/hu/${hu}`,
    en: `/content/images/apps/${service}/en/${en}`,
  },
});

const menhelyScreenshots: ServiceScreenshot[] = [
  appShot('menhely', 0, '01-iranyitopult.png', '01-dashboard.png'),
  appShot('menhely', 1, '02-allatok-lista.png', '02-animals-list.png'),
  appShot('menhely', 2, '03-allat-adatlap.png', '03-animal-detail.png'),
  appShot('menhely', 3, '05-ertesitesek.png', '04-notifications.png'),
];

const gazdiScreenshots: ServiceScreenshot[] = [
  appShot('gazdi', 0, '01-allataim.png', '01-my-pets.png'),
  appShot('gazdi', 1, '02-allat-adatlap.png', '02-pet-detail.png'),
  appShot('gazdi', 2, '03-egeszseg-idovonal.png', '03-health-timeline.png'),
  appShot('gazdi', 3, '04-egeszseg-testsuly.png', '04-weight.png'),
  appShot('gazdi', 4, '05-dokumentumok.png', '05-documents.png'),
  appShot('gazdi', 5, '06-vendegsegbe-kuldes-menu.png', '06-boarding-menu.png'),
  appShot('gazdi', 6, '07-vendegseg-atadas.png', '07-boarding-handover.png'),
];

export const services: Service[] = [
  {
    id: 'rehab',
    slug: 'rehab',
    nameKey: 'services.rehab.name',
    taglineKey: 'services.rehab.tagline',
    shortDescriptionKey: 'services.rehab.shortDescription',
    descriptionKey: 'services.rehab.description',
    featuresKeys: [
      'services.rehab.features.0',
      'services.rehab.features.1',
      'services.rehab.features.2',
      'services.rehab.features.3',
    ],
    accentColor: 'var(--color-rehab)',
    logo: rehabLogo,
  },
  {
    id: 'menhely',
    slug: 'menhely',
    nameKey: 'services.menhely.name',
    taglineKey: 'services.menhely.tagline',
    shortDescriptionKey: 'services.menhely.shortDescription',
    descriptionKey: 'services.menhely.description',
    featuresKeys: [
      'services.menhely.features.0',
      'services.menhely.features.1',
      'services.menhely.features.2',
      'services.menhely.features.3',
    ],
    accentColor: 'var(--color-menhely)',
    logo: menhelyLogo,
    screenshots: menhelyScreenshots,
    webAppUrl: 'https://menhely.chipet.app',
    webAppKind: 'signIn',
    // videos: [
    //   {
    //     id: 'menhely-demo-1',
    //     titleKey: 'services.menhely.videos.0.title',
    //     descriptionKey: 'services.menhely.videos.0.description',
    //     src: '/videos/chipet-menhely-preview.mp4',
    //   },
    // ],
  },
  {
    id: 'gazdi',
    slug: 'gazdi',
    nameKey: 'services.gazdi.name',
    taglineKey: 'services.gazdi.tagline',
    shortDescriptionKey: 'services.gazdi.shortDescription',
    descriptionKey: 'services.gazdi.description',
    featuresKeys: [
      'services.gazdi.features.0',
      'services.gazdi.features.1',
      'services.gazdi.features.2',
      'services.gazdi.features.3',
    ],
    accentColor: 'var(--color-gazdi)',
    logo: gazdiLogo,
    screenshots: gazdiScreenshots,
    // NOTE (2026-08-02): this host currently serves an empty Apache vhost, not
    // the app — the CI FTP deploy appears to write to a nested public_html.
    // The link works as soon as that deploy target is corrected.
    webAppUrl: 'https://gazdi.chipet.app',
    webAppKind: 'public',
  },
];

export const getServiceBySlug = (slug: string): Service | undefined =>
  services.find((s) => s.slug === slug);
